import * as editCoordinators from './edit'
import * as loadCoordinators from './load'
import * as sectionSaveCoordinators from './sectionSave'

export default Object.freeze({
  ...editCoordinators,
  ...loadCoordinators,
  ...sectionSaveCoordinators,
})
